import { Record } from "immutable";

import createFromJS from "../../../createFromJS";
import { RangeRecord } from "../../helper/RangeRecord";

export const ScrollPositionRecord = Record({
  viewport: RangeRecord(),
  canvas: RangeRecord(),
  zoom: 1,
  absoluteScroll: 0,
  relativeScroll: 0
});

const data = {
  objects: {
    viewport: "RangeRecord",
    canvas: "RangeRecord"
  }
};
createFromJS.registerCallback("ScrollPositionRecord", createFromJS.createNestedCallback(ScrollPositionRecord, data));
